import { reportConstants } from '../constants/report.constants';

export function report(state = {}, action) {
  switch (action.type) {
    case reportConstants.WORKJOURNEY_FETCH_REQUEST:
    case reportConstants.INTEGRATIONLOG_FETCH_REQUEST:
    case reportConstants.LASTCONTACT_FETCH_REQUEST:
    case reportConstants.NOTIFICATION_FETCH_REQUEST:
    case reportConstants.REPROCESS_REQUEST:
    case reportConstants.ACCESS_FETCH_REQUEST:
    case reportConstants.ACTIVITY_INTERVAL_REQUEST:
    case reportConstants.ACTIVITY_SUMMARY_REQUEST:
    case reportConstants.ACTIVITY_DASHBOARD_REQUEST:
    case reportConstants.APP_ACTIVITY_SUMMARY_REQUEST:
    case reportConstants.MIGRATE_ACTIVITY_INTERVAL_REQUEST:
    case reportConstants.REPROCESS_JOURNEY_REQUEST:
    case reportConstants.MAILLOG_FETCH_REQUEST:
    case reportConstants.LICENSEUSAGE_CURRENT_REQUEST:
    case reportConstants.LICENSEUSAGE_HISTORY_REQUEST:
    case reportConstants.LICENSEUSAGE_FILE_REQUEST:
    case reportConstants.APPROVEDREQUESTS_FETCH_REQUEST:
    case reportConstants.SESSIONS_FETCH_REQUEST:
    case reportConstants.OUTSIDEJOURNEY_FETCH_REQUEST:
    case reportConstants.LASTCONTACT_PDF_REQUEST:
      return {
        ...state,
        loading: true
      };
    case reportConstants.REPROCESS_JOURNEY_SUCCESS:
      return {
        ...state,
        reprocessJourney: action.reprocessJourney,
        loading: false
      };
    case reportConstants.ACTIVITY_SUMMARY_SUCCESS:
      return {
        ...state,
        activitySummary: action.activitySummary,
        loading: false
      };
    case reportConstants.APP_ACTIVITY_SUMMARY_SUCCESS:
      return {
        ...state,
        appActivitySummary: action.appActivitySummary,
        loading: false
      };
    case reportConstants.ACTIVITY_DASHBOARD_SUCCESS:
      return {
        ...state,
        activityDashboard: action.activityDashboard,
        loading: false
      };
    case reportConstants.WORKJOURNEY_FETCH_SUCCESS:
      return {
        ...state,
        workJourney: action.workJourneyRegisters,
        loading: false
      };
    case reportConstants.INTEGRATIONLOG_FETCH_SUCCESS:
      return {
        ...state,
        integrationLogs: action.integrationLogs,
        loading: false
      };
    case reportConstants.NOTIFICATION_FETCH_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
        loading: false
      };
    case reportConstants.REPROCESS_SUCCESS:
      return {
        ...state,
        workJourneyReprocess: action.clockReprocess,
        loading: false
      };
    case reportConstants.LASTCONTACT_FETCH_SUCCESS:
      return {
        ...state,
        lastContact: action.lastContactRegisters,
        loading: false
      };
    case reportConstants.ACCESS_FETCH_SUCCESS:
      return {
        ...state,
        access: action.accessRegisters,
        loading: false
      };
    case reportConstants.ACTIVITY_INTERVAL_SUCCESS:
      return {
        ...state,
        activityInterval: action.activityIntervalRegisters,
        loading: false
      };
    case reportConstants.MIGRATE_ACTIVITY_INTERVAL_SUCCESS:
      return {
        ...state,
        migrateActivityInterval: action.migrateActivityInterval,
        loading: false
      };
    case reportConstants.MAILLOG_FETCH_SUCCESS:
      return {
        ...state,
        mailLogs: action.mailLogs,
        loading: false
      };
    case reportConstants.LICENSEUSAGE_CURRENT_SUCCESS:
      return {
        ...state,
        licenseUsageCurrent: action.licenseUsageCurrent,
        loading: false
      };
    case reportConstants.LICENSEUSAGE_HISTORY_SUCCESS:
      return {
        ...state,
        licenseUsageHistory: action.licenseUsageHistory,
        loading: false
      };
    case reportConstants.LICENSEUSAGE_FILE_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case reportConstants.APPROVEDREQUESTS_FETCH_SUCCESS:
      return {
        ...state,
        approvedRequests: action.approvedRequests,
        loading: false
      };
    case reportConstants.SESSIONS_FETCH_SUCCESS:
      return {
        ...state,
        sessionsReport: action.sessionsReport,
        loading: false
      };
    case reportConstants.OUTSIDEJOURNEY_FETCH_SUCCESS:
      return {
        ...state,
        outsideJourney: action.outsideJourney,
        loading: false
      };
    case reportConstants.LASTCONTACT_PDF_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case reportConstants.WORKJOURNEY_FETCH_FAILURE:
    case reportConstants.INTEGRATIONLOG_FETCH_FAILURE:
    case reportConstants.NOTIFICATION_FETCH_FAILURE:
    case reportConstants.REPROCESS_FAILURE:
    case reportConstants.LASTCONTACT_FETCH_FAILURE:
    case reportConstants.ACCESS_FETCH_FAILURE:
    case reportConstants.ACTIVITY_INTERVAL_FAILURE:
    case reportConstants.ACTIVITY_SUMMARY_FAILURE:
    case reportConstants.ACTIVITY_DASHBOARD_FAILURE:
    case reportConstants.APP_ACTIVITY_SUMMARY_FAILURE:
    case reportConstants.MIGRATE_ACTIVITY_INTERVAL_FAILURE:
    case reportConstants.REPROCESS_JOURNEY_FAILURE:
    case reportConstants.MAILLOG_FETCH_FAILURE:
    case reportConstants.LICENSEUSAGE_CURRENT_FAILURE:
    case reportConstants.LICENSEUSAGE_HISTORY_FAILURE:
    case reportConstants.LICENSEUSAGE_FILE_FAILURE:
    case reportConstants.APPROVEDREQUESTS_FETCH_FAILURE:
    case reportConstants.SESSIONS_FETCH_FAILURE:
    case reportConstants.OUTSIDEJOURNEY_FETCH_FAILURE:
    case reportConstants.LASTCONTACT_PDF_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}
